// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uGai","largestCol":"styles_largestCol__3-FUI","smallestCol":"styles_smallestCol__1_j4t"};